export default "__VITE_ASSET__CTDFIuSL__"